import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/apps/charging/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/apps/charging/components/Providers/Providers.tsx");
